import { OverlayPanel } from "primereact/overlaypanel";
import React from "react";
import { InvoiceActionIcon } from "../../../customer_profile/CustomerProfileNew/Components/Payments/components/Invoices/assets/Assets";
export default function TemplateAction({
  setCurrentSelectedRow,
  setCurrentActiveScreen,
  rowData,
}) {
  const roleref = React.useRef(null);
  return (
    <>
      <div className="flex align-items-center justify-content-end">
        <div
          onClick={(e) => {
            roleref.current.toggle(e);
          }}
        >
          <span className="actionbtnmain">
            <InvoiceActionIcon />
          </span>
        </div>
        <div className="roleoverlay">
          <OverlayPanel
            ref={roleref}
            style={{
              backgroundColor: "#F8F9FA",
              width: "10rem",
              height: "11.2rem",
              border: "none !important",
            }}
          >
            <div
              style={{
                height: "14rem",
                backgroundColor: "#F8F9FA",
                boxShadow: " 0rem 0.4rem 1rem 0rem #2725A833",
              }}
              className="flex flex-row align-content-center flex-wrap w-full overlay"
            >
              <div
                className="flex  justify-content-start align-items-center overlaycontent"
                style={{
                  height: "3.2rem",
                  paddingLeft: "1.45rem",
                  width: "10rem",
                }}
                onClick={() => {
                  setCurrentSelectedRow({ ...rowData });
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: false,
                    isEdit: false,
                    isView: false,
                    isDownload: true,
                  }));
                  roleref.current.hide();
                }}
              >
                <div className="inner">
                  <label>Download</label>
                </div>
              </div>
              <div
                className="flex  justify-content-start align-items-center overlaycontent"
                style={{
                  height: "3.2rem",
                  paddingLeft: "1.45rem",
                  width: "10rem",
                }}
                onClick={() => {
                  setCurrentSelectedRow({ ...rowData });
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: false,
                    isEdit: false,
                    isDownload: false,
                    isView: true,
                  }));
                  roleref.current.hide();
                }}
              >
                <div className="inner">
                  <label>View</label>
                </div>
              </div>
              <div
                className="flex  justify-content-start align-items-center overlaycontent"
                style={{
                  height: "3.2rem",
                  paddingLeft: "1.45rem",
                  width: "10rem",
                }}
                onClick={() => {
                  setCurrentSelectedRow({ ...rowData });
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: false,
                    isEdit: true,
                    isDownload: false,
                    isView: false,
                  }));
                  roleref.current.hide();
                }}
              >
                <div className="inner">
                  <label>Edit</label>
                </div>
              </div>
              <div
                className="flex  justify-content-start align-items-center overlaycontent"
                style={{
                  height: "3.2rem",
                  paddingLeft: "1.45rem",
                  width: "10rem",
                }}
                onClick={() => {
                  setCurrentSelectedRow({ ...rowData });
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: true,
                    isEdit: false,
                    isDownload: false,
                  }));
                  roleref.current.hide();
                }}
              >
                <div className="inner">
                  <label>Delete</label>
                </div>
              </div>
            </div>
          </OverlayPanel>
        </div>
      </div>{" "}
    </>
  );
}
